import {
  GET_WMS_STOCK_REQUEST,
  GET_WMS_STOCK_SUCCESS,
  GET_WMS_STOCK_FAILURE,
  DOWNLOAD_WMS_STOCK_REQUEST,
  DOWNLOAD_WMS_STOCK_SUCCESS,
  DOWNLOAD_WMS_STOCK_FAILURE,
} from "./wmsStockTypes";
import axios from "axios";
import Config from "../../../config/index";
let baseUrl = Config.baseUrl;
let baseUrlReport = Config.baseUrlReport;

const getWmsStockRequest = () => {
  return {
    type: GET_WMS_STOCK_REQUEST,
  };
};

const getWmsStockSuccess = (payload) => {
  return {
    type: GET_WMS_STOCK_SUCCESS,
    payload: payload,
  };
};

const getWmsStockFailure = (error) => {
  return {
    type: GET_WMS_STOCK_FAILURE,
    payload: error,
  };
};

const getWmsStock = (
  pageNo,
  rowsPerPage,
  search,
  warehouseId,
  status,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getWmsStockRequest());

    let url = `${baseUrlReport}/wms_stock?download=0&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&warehouseCode=${warehouseId}&allStock=${status}`;
    axios
      .get(url, headers)
      .then((response) => {

        dispatch(getWmsStockSuccess(response.data));
      })
      .catch((err) => {

        dispatch(getWmsStockFailure(err.message));
      });
  };
};
const getWmsStockDownloadRequest = () => {
  return {
    type: DOWNLOAD_WMS_STOCK_REQUEST,
  };
};

const getWmsStockDownloadSuccess = (payload) => {
  return {
    type: DOWNLOAD_WMS_STOCK_SUCCESS,
    payload: payload,
  };
};

const getWmsStockDownloadFailure = (error) => {
  return {
    type: DOWNLOAD_WMS_STOCK_FAILURE,
    payload: error,
  };
};

const getWmsStockDownload = (
  pageNo,
  rowsPerPage,
  search,
  warehouseId,
  status,
  jwtToken  
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getWmsStockDownloadRequest());

    let url = `${baseUrlReport}/wms_stock?download=1&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&warehouseCode=${warehouseId}&allStock=${status}`;
    axios
      .get(url, headers)
      .then((response) => {

        dispatch(getWmsStockDownloadSuccess(response.data));
      })
      .catch((err) => {

        dispatch(getWmsStockDownloadFailure(err.message));
      });
  };
};

export { getWmsStock,getWmsStockDownload };
